module.exports = __webpack_public_path__ + "static/img/ic_quiz_white.20547b3b.svg";